import React, { createContext, useContext, useState, useEffect } from "react";
import { Dockets } from "../services";
import { useLocation } from "react-router-dom";

/**
 * The React Context object for docket data
 */
const DocketContext = createContext();

/**
 * Convenience hook for accessing docket information
 */
const useDockets = () => useContext(DocketContext);

/**
 * Provides docket data to the component hierarchy to which it is applied, and
 * encapsulates API service call logic.
 */
function DocketProvider({ entityId, entityType, children }) {
  const [loading, setLoading] = useState(true);
  const [dockets, setDockets] = useState({
    result: [],
  });

  const { search } = useLocation();
  let docketsContext = "filings";
  if (search.includes("case_type")) {
    docketsContext = "types";
  } else if (search.includes("court")) {
    docketsContext = "counsel_other_courts";
  }

  const searchString = search.slice(1);

  useEffect(() => {
    Dockets.get(docketsContext, entityId, searchString, entityType).then(
      (resp) => {
        setDockets(resp.data);
        setLoading(false);
      },
    );
  }, [entityId, searchString, docketsContext, entityType]);

  return (
    <DocketContext.Provider value={{ dockets, loading }}>
      {children}
    </DocketContext.Provider>
  );
}

export { DocketProvider, useDockets };
